<template>
  <div class="buttons">
    <div class="field has-addons">
      <p v-if="isDelete" class="control">
        <button class="button" @click="changeModal('delete')">
          <span class="icon is-small">
            <i class="fas fa-trash"></i>
          </span>
          <span>{{ $t("users.delete") }}</span>
        </button>
      </p>
      <p class="control">
        <button
          v-if="isMfa"
          class="button is-outline"
          @click="changeModal('mfa')"
        >
          <span class="icon is-small">
            <i class="fas fa-mobile"></i>
          </span>
          <span>{{ $t("auth.stopMfa") }}</span>
        </button>
      </p>
    </div>
  </div>
  <Modal
    :imageModalView="deleteModalView"
    :modalTitle="$t('users.delete')"
    :modalAction="$t('Delete')"
    @close="changeModal('delete')"
    @doAction="deleteUser()"
  >
    <h6 class="title is-6">{{ userName }}</h6>
    <p class="notification is-danger">{{ $t("users.deleteMessage") }}<br /></p>
    <p>
      {{ $t("users.deleteMessageConfirm") }}
    </p>
  </Modal>

  <Modal
    :imageModalView="mfaModalView"
    :modalTitle="$t('auth.stopMfa')"
    :modalAction="$t('auth.stopMfa')"
    :buttonColor="'is-primary'"
    @close="changeModal('mfa')"
    @doAction="disableMfa()"
  >
    <h6 class="title is-6">{{ userName }}</h6>
    <p class="notification is-info is-light">
      {{ $t("users.mfaUnsetMessage") }}<br />
    </p>
    <p>
      {{ $t("users.deleteMessageConfirm") }}
    </p>
  </Modal>
</template>
<script>
import Modal from "@/components/Modal.vue";
import { ref } from "vue";

export default {
  emits: ["deleteUser", "disableMfa"],
  components: {
    Modal,
  },
  props: {
    isDelete: {
      type: Boolean,
      require: true,
    },
    isMfa: {
      type: Boolean,
      require: true,
    },
    userName: {
      type: String,
      require: true,
    },
  },
  setup(_, context) {
    const deleteModalView = ref(false);
    const mfaModalView = ref(false);

    const changeModal = (modal) => {
      if (modal === "delete") {
        deleteModalView.value = !deleteModalView.value;
      } else if (modal === "mfa") {
        mfaModalView.value = !mfaModalView.value;
      }
    };

    const deleteUser = () => {
      deleteModalView.value = false;
      context.emit("deleteUser");
    };

    const disableMfa = () => {
      mfaModalView.value = false;
      context.emit("disableMfa");
    };

    return {
      deleteModalView,
      mfaModalView,
      changeModal,
      deleteUser,
      disableMfa,
    };
  },
};
</script>
